<video #video autoplay playsinline x-webkit-airplay="false" type="video/mp4" [muted]="muteAudio" [src]="videoUrl() | msTrust: 'resourceurl'"></video>
@if (loaderVisible) {
    <ds-loading-spinner class="loader-alignment" />
}
@if (muteVisible) {
    <vn-icon class="video-mute-unmute-button" size="32" [name]="muteAudio ? 'theme-sound-mute' : 'theme-sound-loud'" (click)="toggleMute()" />
}
